import { useMutation } from "@apollo/client";
import { REMOVE_PRICE_RULE } from "../price-rule.queries";
import {
  RemovePriceRuleMutation,
  RemovePriceRuleMutationVariables,
} from "../../../__generated__/RemovePriceRuleMutation";

export const useRemovePriceRule = () => {
  return useMutation<RemovePriceRuleMutation, RemovePriceRuleMutationVariables>(
    REMOVE_PRICE_RULE,
    {
      refetchQueries: ["PriceRulesQuery"],
    }
  );
};
